<template lang="pug">
  div(v-if="!isHcpView")
    div(id='lesson-scroller')
      mu-card(align="left")
      div(class="content")
        mu-flexbox
          mu-flexbox-item(v-if="$store.state.status.payment.paid", grow="2", style="padding-left: 16px;", class="ellipsis")
            span(v-if="!isLoading && currentLessonObject !== false") {{ $t('message.lessonScrollerWeekPrefix') }}
            strong
              router-link(:to="'lesson/' + currentLessonObject.permalink")
                span(class="bold", v-text="!isLoading ? ' ' + currentLessonObject.week_name + ': '  +  currentLessonObject.title : ''")
            span(v-text="isLoading ? $t('message.loadingText'): ''")
          mu-flexbox-item(shrink="3", align="right")
            mu-icon-button(
            icon="chevron_left",
            @click.native="goLeft($event)",
            :disabled="isLeftLocked || isLoading"
            )
            mu-icon-button(
            icon="chevron_right",
            @click.native="goRight($event)",
            :disabled="isRightLocked || isLoading"
            )
      mu-grid-list(:cellHeight="240", class='gridlist-scroller', id="animationRail")
        mu-grid-tile(v-for="loader, index in dummyLoaders", :key="'loader-' + index", class="outerItem dummyTile", v-if="isLoading")
          mu-linear-progress(slot="title", :size="100")
          mu-linear-progress(slot="subTitle")
        mu-grid-tile(v-for="(tile, index) in list", v-bind:class="{locked: tile.status.locked === true || !$store.state.status.payment.paid}", :key="'lesson' + index", @click.native="goToPermalink(tile)" class="outerItem" v-bind:id="'lesson' + (index+1)")
          mu-chip(v-if="tile.hasPersonalization", backgroundColor="#0179d5", color="white", style="position: absolute; top: 8px; right: 8px; z-index: 1") {{ $t('message.labelPersonalized') }}
          img(:src="tile.image_url", :alt="tile.title")
          span(slot="title", v-text="tile.title")
          span(slot="subTitle", v-text="tile.week_name.replace('Week', $t('message.labelWeek'))")
          mu-icon-button(v-if="tile.status.locked === false && $store.state.status.payment.paid", icon="play_arrow", slot="action")
          mu-icon-button(v-if="tile.status.locked === true || !$store.state.status.payment.paid", icon="lock", slot="action")
          mu-grid-tile(class="innerItem", v-for="(bonus, index) in tile.bonus_modules", v-bind:class="{locked: tile.status.locked === true || !$store.state.status.payment.paid}", key="'bonus' + index", @click.native="goToBonus(bonus, tile)", slot="action")
            mu-chip(backgroundColor="#3d8517", color="white", style="position: absolute; top: 8px; right: 8px; z-index: 1") {{$t('message.labelBonus')}}
            img(:src="bonus.image_url")
            span(slot="title", v-text="bonus.title")
            span(slot="subTitle", v-text="bonus.subTitle.replace('Week', $t('message.labelWeek'))")
            mu-icon-button(v-if="tile.status.locked === false && $store.state.status.payment.paid", icon="play_arrow", slot="action")
            mu-icon-button(v-if="tile.status.locked === true || !$store.state.status.payment.paid", icon="lock", slot="action")
</template>
<script>
  import LessonsApi from '../../../api/Lessons';

  import {TweenMax, Power2, TimelineLite} from 'gsap';
  import ScrollerMixin from "../../../mixins/ScrollerMixin";
  import HCPMixin from "../../../mixins/HCPMixin";
  export default {
    mixins: [ScrollerMixin, HCPMixin],
    name: "lesson-inline-grid",
    data() {
      return {
        isLoading: true,
        isMouseDown: undefined,
        activeLesson: 0,
        animationRail: undefined,
        dummyLoaders: 10,
        list: []
      }
    },
    mounted() {
      let self = this;
      self.isLoading = true;
      self.animationRail = document.getElementById('animationRail');
      if (self.$store.state.lessons.length > 0) {
        self.list = self.$store.state.lessons;
        self.$nextTick(function () {
          self.setInitialActiveLesson();
          self.moveBonusModules('quick');
          self.isLoading = false;
        });
      }
      else {
        self.isLoading = true;
        LessonsApi.getLessonsList()
          .then(function (response) {
            self.list = response.data;
            self.$store.state.lessons = response.data;
            self.$nextTick(function () {
              self.setInitialActiveLesson();
              self.moveBonusModules('wait');
              self.isLoading = false;
            });
          })
      }
    },
    methods: {
      goLeft() {
        let self = this;
        self.animateToLesson(self.activeLesson - 1)
      },
      goRight() {
        let self = this;
        self.animateToLesson(self.activeLesson + 1)
      },
      animateToLesson(lessonNumber) {
        let self = this;
        self.activeLesson = lessonNumber;
        if (self.animationRail !== undefined)
          if (self.doesElementsExist('#lesson' + (lessonNumber))) {
            TweenLite.to(self.animationRail, 0.3, {
              scrollTo: {
                x: $('#lesson' + (lessonNumber))
              }
            })
          }
      },
      doesElementsExist(elName) {
        return $(elName).length !== 0
      },
      animateToUnlocked(mode) {
        let self = this;
        let animationDuration;
        (mode === 'wait') ? animationDuration = 0.5 : animationDuration = 0.3;
        if (self.animationRail !== undefined) {
          if (self.list.length > 0 && self.currentLesson !== false) {
            self.activeLesson = parseInt(String(self.currentLesson).replace("#lesson", ""));
            if (self.doesElementsExist(self.currentLesson)) {
              TweenLite.to(self.animationRail, animationDuration, {
                scrollTo: {
                  x: $(self.currentLesson)
                }
              })
            }
          }
        }
      },
      moveBonusModules(mode) {
        let self = this;
        const outerItem = $('.outerItem');

        if (self.doesElementsExist('.outerItem')) {
          outerItem.each(function (index, e) {
            const elem = $(e);
            const $items = elem.find('.innerItem');
            $($items).each(function (n, e) {
              $(e).insertAfter($('.outerItem:eq(' + index + ')'));
              $(e).show()
            })
          });

          let timeToWait;
          (mode === 'wait') ? timeToWait = 1200 : timeToWait = 600;

          const wait = setTimeout(function () {
           // self.animateToUnlocked(mode);
            clearTimeout(wait);
          }.bind(self), timeToWait);
        }

      },
      setInitialActiveLesson() {
        let self = this;
        self.activeLesson = self.list.filter(function (lesson) {
          return lesson.status.locked === false;
        }).length;
      },
      goToBonus(bonus, tile) {
        let self = this;
        if(self.$store.state.status.payment.paid === true) {
          if (tile.status.locked !== true) {
            self.$router.push(
              {
                name: 'LessonBonus',
                params: {
                  id: bonus.id
                }
              }
            );
          }
        } else {
          self.triggerPaywall();
        }
      },
      goToPermalink(tile) {
        let self = this;
        if(self.$store.state.status.payment.paid === true) {
          if (tile.status.locked !== true) {
            self.$router.push(
              {
                name: 'Lesson',
                params: {
                  permalink: tile.permalink
                }
              }
            );
          }
        } else {
          self.triggerPaywall();
        }
      },
      triggerPaywall() {
        this.$EventBus.$emit('App::triggerPaywall', true);
      }
    },
    computed: {
      isLeftLocked() {
        let self = this;
        return self.activeLesson === 1;
      },
      isRightLocked() {
        let self = this;
        return self.activeLesson === self.list.length;
      },
      currentLessonObject() {
        let self = this;
        if (self.list.length > 0) {
          let items =  self.list.filter(function (lesson) {
            return lesson.status.locked === false;
          });
          if(items.length > 0) {
            return items[items.length-1];
          }
        }
        else {
          return false;
        }
      },
      currentLesson() {
        let self = this;
        if (self.list.length > 0) {
          let currentLesson = self.list.filter(function (lesson) {
            return lesson.status.locked === false;
          });
          return "#lesson" + currentLesson.length;
        }
        else {
          return false;
        }
      }
    }
  }
</script>
<style lang="less">
  @import "./lesson-inline-grid.less";

  #lesson-scroller {
    .mu-grid-tile>img {
      width: 100%;
    }
    .innerItem.locked.has-tooltip {
      cursor: not-allowed !important;
    }

    .innerItem.locked, .outerItem.locked {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .outerItem {
      cursor: pointer;
    }

    .dummyTile {
      background: #ccc;UN
      border-right: 1px solid white;
    }

    .ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>



// WEBPACK FOOTER //
// LessonInlineGrid.vue?7b887bc3